<template>
    <el-dialog v-dialogDrag class="dialog" width="700px"
               :visible.sync="dialogVisible" v-loading="dialoading"
               append-to-body
               @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                部门权选择
            </div>
        </div>
        <div class="dialog_body">
            <el-table
                    ref="treeTable"
                    :data="dataList"
                    height="400"
                    style="width: 100%;"
                    highlight-current-row
                    :header-cell-style="headerStyle"
                    :cell-style="cellStyle"
                    row-key="id"
                    @row-click="selRow"
                    @select-all="selectAll"
                    @select="handleSelectionChange"
                    default-expand-all
                    :tree-props="{children: 'children', hasChildren: 'hasChildren' ,disabled: 'disabled'}">
                    border>
                <el-table-column
                        type="index"
                        width="50">
                </el-table-column>
                <el-table-column
                        type="selection"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="name"
                        label="部门名称">
                </el-table-column>
            </el-table>
            <div style="text-align: center;padding: 10px 0px 20px 0px">
                <el-button type="danger" @click="close">取 消</el-button>
                <el-button type="primary" @click="submitForm">保 存</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "selRole",
        props: ['formData', 'loading'],
        data() {
            return {
                searchData: {
                    fields: [{
                        tag: "el-input",
                        label: "部门名称",
                        vModel: "name",
                    }],
                    formData: {
                        name: ""
                    },
                },
                dialogVisible: true,
                dialoading: false,
                dataList: [],
            }
        },
        async mounted() {
            await this.getListData();
            if(this.deptData){
                this.defaultSelect();
            }
        },
        methods: {
            submitForm() {
                let rows = this.$refs.treeTable.selection;
                if(rows.length>0) {
                    let departmentId = [];
                    let departmentName = [];
                    rows.map(item => {
                        departmentId.push(item.id);
                        departmentName.push(item.name);
                    })
                    this.formData.departmentIds = departmentId.toString();
                    this.formData.departmentIdsName = departmentName.toString();
                    this.$emit("checkRow");
                }else{
                    this.$message({message: '请选择一个部门', type: 'error'});
                }
            },
            headerStyle() {
                return "text-align:center;height:45px;line-hight:45px;padding: 1px 0;background-color:#f2f2f2;border-left:1px solid #e5e6e8;border-top:1px solid #e5e6e8;border-bottom:1px solid #e5e6e8"
            },
            cellStyle(row) {
                return "text-align:left"
            },
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            async getListData() {
                this.dialoading = true;
                let param = {
                    url: "/department/selZTree",
                    param: {
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == '0') {
                    this.dataList = data.data.jsonStr;
                }
                this.dialoading = false;
            },
            selRow(row){
                //
            },
            //点击全选复选框
            selectAll() {
                let data = this.$refs.treeTable.data
                data.forEach(item => {
                    if (item.checked == true) {
                        this.clearRow([item]);
                    } else {
                        this.checkRow([item]);
                    }
                })
            },
            //点击复选框事件
            handleSelectionChange(select, row) {
                if (row.checked == true) {
                    this.$refs.treeTable.toggleRowSelection(row, false);
                    this.clearRow([row]);
                } else {
                    this.$refs.treeTable.toggleRowSelection(row, true);
                    this.checkRow([row]);
                }
            },
            //取消选中递归
            clearRow(data) {
                Array.from(data).forEach(row => {
                    row.checked = false;
                    this.$refs.treeTable.toggleRowSelection(row, false);
                    if (row.children) this.clearRow(row.children);
                })
            },
            //选中递归
            checkRow(data) {
                Array.from(data).forEach(row => {
                    row.checked = true;//选中是字段值为true
                    this.$refs.treeTable.toggleRowSelection(row, true);
                    if (row.children) this.checkRow(row.children);
                })
            },
            //默认选中
            defaultSelect() {
                this.$nextTick(() => {
                    this.defaultChild(this.dataList)
                    // let selrow = this.dataList.find(item => {
                    //     if(this.deptData.id)
                    //         return item.id == this.deptData.id
                    //     else if(this.deptData.name)
                    //         return item.name == this.deptData.name
                    //     else
                    //         return item.name == this.deptData
                    // })
                    // if(selrow>-1)
                    //     this.$refs.treeTable.setCurrentRow(selrow);
                });
            },

            defaultChild(list){
                for(let i=0;i<list.length;i++){
                    if(this.deptData.id){
                        if(list[i].id == this.deptData.id){
                            this.$refs.treeTable.setCurrentRow(list[i]);
                            return;
                        }
                    }
                    if(this.deptData.name){
                        if(list[i].name == this.deptData.name){
                            this.$refs.treeTable.setCurrentRow(list[i]);
                            return;
                        }
                    }
                    if(list[i].children){
                        this.defaultChild(list[i].children);
                    }
                }
            },

            toPage(obj) {
                this.getListData();
            },
        },
    }
</script>
